module.exports = __webpack_public_path__ + "static/media/campus_2.28cd60b8.png";